import * as Sentry from "@sentry/browser";
import postHog from "posthog-js";

export const identifyUserForAnalytics = async (user: {
  user_id: string;
  email: string;
  name: string;
  workspace_id?: string;
  domain?: string;
}) => {
  if (user.workspace_id) {
    postHog.group("workspace", user.workspace_id, {
      domain: user.domain,
      workspace_id: user.workspace_id,
    });

    postHog.setGroupPropertiesForFlags(
      {
        properties: {
          email: user.email,
          domain: user.domain,
          workspace_id: user.workspace_id,
        },
      },
      true,
    );
  }
  postHog?.identify(user.email, user);
  // Set user information in Sentry
  Sentry.setUser({
    user_id: user.user_id,
    email: user.email,
    name: user.name,
    org_id: user.workspace_id,
    domain: user.domain,
  });
};
